// react-router-dom components
import { Link } from "react-router-dom";

// @mui material components
import Card from "@mui/material/Card";

// @mui icons

// Material Dashboard 2 PRO React components
import MDBox from "@core/components/MDBox";
import MDButton from "@core/components/MDButton";
import MDInput from "@core/components/MDInput";
import MDTypography from "@core/components/MDTypography";

// Authentication layout components

// Images
import bgImage from "@core/assets/images/bg-sign-in-basic.jpeg";
import GuestLayout from "layouts/guest-layout";

function VerifyEmail() {
  return (
    <GuestLayout image={bgImage}>
      <Card sx={{ maxWidth: "400px", mx: "auto"}}>
        <MDBox
          
          bgColor="info"
          borderRadius="lg"
          coloredShadow="info"
          mx={2}
          mt={-3}
          p={2}
          mb={1}
          textAlign="center"
        >
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
            Verify Email
          </MDTypography>
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          <MDBox component="form" role="form">
            <MDBox mb={2}>
              <MDInput type="text" label="Verification Code" fullWidth />
            </MDBox>
            <MDBox mt={4} mb={1}>
              <MDButton  color="info">
                Verify
              </MDButton>
            </MDBox>
            <MDBox mt={3} mb={1} textAlign="center">
              <MDTypography variant="button" color="text">
                Didn&apos;t receive the code?{" "}
                <MDTypography
                  component={Link}
                  to="/sign-up"
                  variant="button"
                  color="info"
                  fontWeight="medium"
                  textGradient
                >
                  Send Again
                </MDTypography>
              </MDTypography>
            </MDBox>
          </MDBox>
        </MDBox>
      </Card>
    </GuestLayout>
  );
}

export default VerifyEmail;
